module.exports = __webpack_public_path__ + "img/tooth13.5f96257a.png";